import moment from "moment";


export function formatDateTime(dt) {
	const jsDate = new Date(dt);
	const mntDate = moment(jsDate).format("LLL");

	return mntDate;
}